module.exports = __webpack_public_path__ + "img/thank-you.d4b3623.png";